export default {
    path: "/changePassword",
    name: "ChangePassword",
    component: () => import(/* webpackChunkName: "changePassword" */ '../../views/changePassword/changePassword.vue')
}